/**
 * Domain types and constants for classifying RF subscriptions by their
 * subscription family (creative vs editorial).
 *
 * The SKU of an RF subscription agreement and the SKU of its subscription
 * price name the subscription family the same way, so one set of patterns
 * serves both. On the server, subscriptionFamilyOfSku in domain/agreements is
 * the one rule that reads them; the browser still reads them in
 * rfSubscriptionPredicates.ts.
 */

export type SubFamily = 'creative' | 'editorial';

export const SUBSCRIPTION_AGREEMENT_SKU_PATTERNS: Record<SubFamily, RegExp> = {
  creative: /SUBGICREATIVE\d+/i,
  editorial: /SUBGIEDITORIAL\d+/i,
};

export type EligibleSubscriptions = {
  gettyCreativeRFSubscription: boolean;
  gettyEditorialRFSubscription: boolean;
};

// Which RF subscriptions the asset itself is included in (from the asset service).
export type SupportedSubscriptions = {
  gettyCreativeRFSubscription: boolean;
  gettyEditorialRFSubscription: boolean;
};
